<template>
  <div ref="otpCont" class="d-flex justify-center">
    <input
        type="tel"
        inputmode="numeric"
        class="digit-box"
        v-for="(el, index) in digitCount"
        v-model="digits[index]"
        :key="el+index"
        :autofocus="index === 0"
        @keydown="handleKeyDown($event, index)"
        @input="handleInput($event, index)"
        @focus="handleFocus($event)"
        maxlength="1"
    />
  </div>
</template>

<script>

export default {
  name: "VueOTPInput",
  props: {
    default: {
      type: String,
      default: ''
    },
    digitCount: {
      type: Number,
      required: true
    },
    timeToResend: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      time: 0,
      digits: [],
      isWaitingToResend: false,
      interval: undefined,
    }
  },
  computed: {
    defaultDigits: function () {
      return this.default && this.default.length === this.digitCount
          ? Array.from(this.default)
          : new Array(this.digitCount).fill(null);
    }
  },
  mounted() {
    this.digits = this.defaultDigits;
    this.time = this.$props.timeToResend;
  },
  methods: {
    isDigitsFull: function () {
      for (const elem of this.digits) {
        if (elem === null || elem === undefined || elem === '') {
          return false;
        }
      }
      return true;
    },
    handleFocus(event) {
      event.target.select();
    },
    handleInput(event, index) {
      const value = event.target.value;
      const formattedValue = value.replace(/\D/g, '');

      if (formattedValue) {
        const lastDigit = formattedValue.slice(-1);

        this.digits.splice(index, 1, lastDigit);

        if (index < this.digitCount - 1) {
          this.$nextTick(() => {
            this.$refs.otpCont.children[index + 1].focus();
          });
        }
      } else {
        this.digits.splice(index, 1, null);
      }

      if (this.isDigitsFull()) {
        this.$emit('handle-code', this.digits.join(''));
      }
    },
    handleKeyDown(event, index) {
      if (event.key === 'Backspace') {
        if (!this.digits[index] && index > 0) {
          this.$refs.otpCont.children[index - 1].focus();
        }
        return;
      }

      if (['ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
        return;
      }
    }
  }
};
</script>

<style scoped>
.digit-box {
  height: 4rem;
  width: 4rem;
  border: 1px solid #c7c7c7;
  display: inline-block;
  border-radius: 5px;
  margin: 5px;
  padding: 0;
  font-size: 3rem;
  text-align: center;
  line-height: 4rem;
}

.digit-box:focus {
  outline: 2px solid #08437B;
  border-color: #08437B;
}

.digit-box::-webkit-outer-spin-button,
.digit-box::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.digit-box {
  -moz-appearance: textfield;
}
</style>
